<ng-container *ngIf="treasuryEvaluationParameters">
    <h2 class="_sansSerif _primary"[i18nKey]="'evaluations.treasury.criteria.title'"></h2>
    <kiwi-spacer [size]="24"></kiwi-spacer>

    <div class="explanation">
        <img src="/assets/images/png/chef.png" class="explanation-img" alt=""/>
        <div class="explanation-text">
            <p [i18nKey]="'evaluations.treasury.criteria.turnover.per.day.explanation'"></p>
            <p [i18nKey]="'evaluations.treasury.availability.weights.explanation'"></p>
        </div>
    </div>

    <form (ngSubmit)="save()" #treasuryMarkCriteriaForm="ngForm" kiwiDaysNumberValidator>
        <div class="grid-x grid-margin-x grid-margin-y">
            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.treasury.criteria.availability.weight'"></span>
                <kiwi-number-input
                    (change)="onValueUpdate()"
                    [(ngModel)]="treasuryEvaluationParameters.availabilityWeight"
                    [min]="treasuryEvaluationParameters.minAvailabilityWeight"
                    [max]="treasuryEvaluationParameters.maxAvailabilityWeight"
                    name="availabilityWeight">
                </kiwi-number-input>
            </label>

            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.treasury.criteria.overdraft.weight'"></span>
                <kiwi-number-input
                    (change)="onValueUpdate()"
                    [(ngModel)]="treasuryEvaluationParameters.overdraftWeight"
                    [min]="treasuryEvaluationParameters.minOverdraftWeight"
                    [max]="treasuryEvaluationParameters.maxOverdraftWeight"
                    name="overdraftWeight"
                    required>
                </kiwi-number-input>
            </label>
        </div>

        <kiwi-spacer [size]="80"></kiwi-spacer>

        <div class="explanation">
            <img src="/assets/images/png/chef.png" class="explanation-img" alt=""/>
            <div class="explanation-text">
                <p [i18nKey]="'evaluations.treasury.criteria.days.number.explanation'"></p>
            </div>
        </div>

        <div class="grid-x grid-margin-x grid-margin-y">
            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.treasury.criteria.days.number.for.maximal.mark'"></span>
                <kiwi-number-input
                    (change)="onValueUpdate()"
                    [(ngModel)]="treasuryEvaluationParameters.daysNumberForMaximalMark"
                    [min]="treasuryEvaluationParameters.minDaysNumberForMaximalMark"
                    [max]="treasuryEvaluationParameters.maxDaysNumberForMaximalMark"
                    name="daysNumberForMaximalMark"
                    [class._orderError]="treasuryMarkCriteriaForm.errors?.daysNumberOrder"
                    required>
                </kiwi-number-input>
            </label>

            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.treasury.criteria.days.number.for.average.mark'"></span>
                <kiwi-number-input
                    (change)="onValueUpdate()"
                    [(ngModel)]="treasuryEvaluationParameters.daysNumberForAverageMark"
                    [min]="treasuryEvaluationParameters.minDaysNumberForAverageMark"
                    [max]="treasuryEvaluationParameters.maxDaysNumberForAverageMark"
                    name="daysNumberForAverageMark"
                    [class._orderError]="treasuryMarkCriteriaForm.errors?.daysNumberOrder"
                    required>
                </kiwi-number-input>
            </label>

            <label class="cell small-24 large-12 xxlarge-8">
                <span [i18nKey]="'evaluations.treasury.criteria.days.number.for.minimal.mark'"></span>
                <kiwi-number-input
                    (change)="onValueUpdate()"
                    [(ngModel)]="treasuryEvaluationParameters.daysNumberForMinimalMark"
                    [min]="treasuryEvaluationParameters.minDaysNumberForMinimalMark"
                    [max]="treasuryEvaluationParameters.maxDaysNumberForMinimalMark"
                    name="daysNumberForMinimalMark"
                    [class._orderError]="treasuryMarkCriteriaForm.errors?.daysNumberOrder"
                    required>
                </kiwi-number-input>
            </label>
        </div>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <div *ngIf="treasuryMarkCriteriaForm.errors?.daysNumberOrder" class="alertMessage _error">
            <i class="fas fa-exclamation-triangle alertMessage-icon"></i>
            <span class="alertMessage-text"[i18nKey]="'evaluations.treasury.criteria.days.number.order.error'"></span>
        </div>

        <kiwi-spacer [size]="48"></kiwi-spacer>

        <div class="grid-x align-center">
            <button class="cell shrink button"
                    type="submit"
                    [disabled]="treasuryMarkCriteriaForm.invalid"
                    name="saveTreasuryMarkCriteria"[i18nKey]="'common.action.save'"></button>
        </div>
    </form>
</ng-container>
